import { FileSearch, Clock, ShieldAlert } from "lucide-react";
import { EyebrowPill } from "@/components/shared/EyebrowPill";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { FeatureCard } from "@/components/shared/FeatureCard";

const problems = [
  {
    icon: FileSearch,
    title: "The 11pm Evidence Hunt",
    description: "Searching through emails, shared drives, and dusty folders the night before an audit—praying you find what you need",
  },
  {
    icon: Clock,
    title: "Spreadsheets That Haven't Moved in Months",
    description: "Compliance registers that nobody updates, standards mappings that don't reflect reality, version chaos everywhere",
  },
  {
    icon: ShieldAlert,
    title: "The Audit Email Arrives. Panic Sets In.",
    description: "The CEO asks if you're audit-ready and you can't give a confident answer. Because nothing is centralised, nothing is current, and you're not sure what ASQA will find.",
  },
];

const Problem = () => {
  return (
    <section className="py-20 md:py-28 bg-white text-ch-acai">
      <div className="container">
        <div className="text-center mb-14 animate-fade-up">
          <EyebrowPill>The Compliance Challenge</EyebrowPill>
          <SectionHeading className="mb-5">
            "Are We Ready?" ...You're Not Sure
          </SectionHeading>
          <p className="text-ch-acai/75 max-w-2xl mx-auto" style={{ fontSize: '23px' }}>
            Because honestly, you don't know — and that's the most uncomfortable place an RTO leader can be.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {problems.map((problem, index) => (
            <FeatureCard
              key={problem.title}
              icon={problem.icon}
              title={problem.title}
              align="left"
              iconStyle="gradient"
              className={`animate-fade-up animate-delay-${(index + 1) * 100}`}
            >
              {problem.description}
            </FeatureCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Problem;
